import { TfiAngleRight } from "react-icons/tfi";
import Container from "../../layout/Container";
import PopupSlider from "./PopupSlider";

const PopupImage = () => {
  return (
    <Container>
      <div className="h-[310px] w-[411px] overflow-hidden rounded-md border border-solid border-darkGreen border-opacity-30">
        <div>
          <div className="relative">
            <img
              src="assets/images/popup/mainimg.png"
              alt="mainimg"
            />
            <div className="absolute top-[105px] right-2 cursor-pointer rounded-full bg-black bg-opacity-20 py-4 px-4 text-white">
              <TfiAngleRight />
            </div>
          </div>
        </div>
        <div className=" my-4 mt-4 flex w-[303px] items-center justify-center gap-x-5">
          <PopupSlider />
        </div>
      </div>
    </Container>
  );
};

export default PopupImage;
